import React from 'react';

const ThumbsDownIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#clip0_20437_43729)">
      <path
        d="M11.1952 9.3V1.5M5.99516 11.978L6.64516 9.3H2.85566C2.65385 9.3 2.4548 9.25301 2.27429 9.16276C2.09377 9.0725 1.93676 8.94145 1.81566 8.78C1.69457 8.61854 1.61274 8.43111 1.57663 8.23255C1.54053 8.03399 1.55115 7.82975 1.60766 7.636L3.12216 2.436C3.20092 2.16597 3.36514 1.92877 3.59016 1.76C3.81519 1.59123 4.08888 1.5 4.37016 1.5H13.1452C13.4899 1.5 13.8206 1.63696 14.0644 1.88076C14.3082 2.12456 14.4452 2.45522 14.4452 2.8V8C14.4452 8.34478 14.3082 8.67544 14.0644 8.91924C13.8206 9.16304 13.4899 9.3 13.1452 9.3H11.3512C11.1093 9.30013 10.8723 9.36772 10.6667 9.49518C10.4612 9.62264 10.2953 9.80491 10.1877 10.0215L7.94516 14.5C7.63864 14.4962 7.33693 14.4232 7.06259 14.2864C6.78825 14.1496 6.54836 13.9526 6.36085 13.7101C6.17334 13.4676 6.04306 13.1859 5.97974 12.8859C5.91641 12.586 5.92169 12.2756 5.99516 11.978Z"
        stroke="#6E7781"
        strokeWidth={1.25}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20437_43729">
        <rect
          width={16}
          height={16}
          fill="white"
          transform="matrix(1 0 0 -1 0 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default ThumbsDownIcon;
